import { Action } from "../../../types/entities";

export function getShortProductJournalActionLabel(action: Action): string {
  if (action === Action.put) {
    return "Добавлен";
  }
  if (action === Action.take) {
    return "Изъят";
  }
  if (action === Action.destroy) {
    return "Списан";
  }

  return "Операция";
}

export function getBoxHistoryProductJournalActionTitle(action: Action): string {
  if (action === Action.put) {
    return "Товар добавлен в коробку";
  }
  if (action === Action.take) {
    return "Товар изъят из коробки";
  }
  if (action === Action.destroy) {
    return "Товар списан";
  }

  return "Операция с товаром";
}

export function getDashboardProductJournalActionTitle(action: Action): string {
  if (action === Action.put) {
    return "Товар добавлен в коробку";
  }
  if (action === Action.take) {
    return "Товар извлечен из коробки";
  }
  if (action === Action.destroy) {
    return "Товар списан";
  }

  return "Операция с товаром";
}

export function getBoxHistoryProductJournalActionTone(
  action: Action,
): "info" | "warning" | "danger" {
  if (action === Action.put) {
    return "info";
  }
  if (action === Action.take) {
    return "warning";
  }

  return "danger";
}

export function getDashboardProductJournalActionTone(
  action: Action,
): "info" | "warning" {
  if (action === Action.destroy) {
    return "warning";
  }

  return "info";
}
